import React, { useEffect, useState } from "react";
import { Route, RouteProps, useLocation } from "react-router-dom";
import BlkLoadingBar from "../coms/BlkLoadingBar";
import { ProdesegNavbar } from "../components/Navbars/ProdesegNavbar";
import { ProdesegFooter } from "../components/Footer/ProdesegFooter";
import { ReactComponent as TextureCircles } from "../assets/img/texture/circles-2.svg";
import { Helmet } from "react-helmet";
import { useUser } from "../custom-hooks/useUser";

interface DashboardProps extends Pick<RouteProps, "component"> {
    path: string;
    title?: string;
    classMainPanel?: string;
    exact?: boolean;
    hideNavbar?: boolean;
    hideFooter?: boolean;
}

const Dashboard: React.FC<DashboardProps> = ({ hideNavbar, ...props }) => {
    const location = useLocation();
    const mainPanel = React.useRef<HTMLDivElement>(null);

    const [dashboardKey, setDashboardKey] = useState("idDashboard");
    const user = useUser();

    React.useEffect(() => {
        if (!mainPanel.current) return;
        document.documentElement.scrollTop = 0;
        mainPanel.current.scrollTop = 0;
    }, [location]);

    useEffect(() => {
        setDashboardKey(JSON.stringify(user));
    }, [location.pathname]);

    return (
        <>
            <BlkLoadingBar />
            <Helmet>
                <title>{props.title}</title>
            </Helmet>
            <div className="position-relative bg-gradient-linear-background min-vh-100">
                <div ref={mainPanel} style={{ [hideNavbar ? "--navbar-height" : ""]: "0px" }}>
                    {hideNavbar ? null : (
                        <>
                            <ProdesegNavbar />
                            <TextureCircles className={"main-textures svg-primary-500"} />
                        </>
                    )}
                    <div key={dashboardKey} className={`main-content ${props?.classMainPanel ?? ""}`}>
                        <Route path={props.path} exact={props?.exact} component={props.component} />
                    </div>
                    {props?.hideFooter ? null : <ProdesegFooter />}
                </div>
            </div>
        </>
    );
};

export default Dashboard;
